import { MapDelta } from "./map/map"
import { Coordinate } from "./models"

export interface TileInteraction { name: string; displayName: string }
export interface TileInteractionTarget {
    coordinate: Coordinate
    layerId: string
    roomId?: string
    interactions: TileInteraction[]
}

/** Tile campaigns advertise verbs on map deltas; caps resolve to their parent tile. */
export const tileInteractionsAt = (
    provider: { getMapDeltaAt: (x: number, y: number, layerId: string) => MapDelta },
    cell: Coordinate,
    options: { includeRoof?: boolean; roofCell?: Coordinate;
        roofBelow?: { roomId: string; provider: { getMapDeltaAt: (x: number, y: number, layerId: string) => MapDelta } } } = {},
): TileInteractionTarget | undefined => {
    if (!cell || !Number.isInteger(cell.x) || !Number.isInteger(cell.y)) return
    const targets = ["sprite3", "sprite2", "sprite", "map3", "map2"].map(layerId => ({ layerId, cell }))
    if (options.includeRoof !== false) targets.splice(options.roofCell ? 0 : 3, 0, { layerId: "sky", cell: options.roofCell ?? cell })
    for (const { layerId, cell } of targets) {
        const hit = provider.getMapDeltaAt(cell.x, cell.y, layerId)
        if (!hit || hit.removed) continue
        const coordinate = hit.context?.parent || cell
        const tile = provider.getMapDeltaAt(coordinate.x, coordinate.y, layerId)
        const interactions = tile && !tile.removed ? tile.context?.tileInteractions : undefined
        if (interactions?.length) return { coordinate: { ...coordinate }, layerId, interactions }
    }
    if (options.roofBelow) {
        const roof = options.roofBelow.provider.getMapDeltaAt(cell.x, cell.y, "sky")
        const interactions = roof && !roof.removed ? roof.context?.tileInteractions : undefined
        if (interactions?.length) return { coordinate: { ...cell }, layerId: "sky", roomId: options.roofBelow.roomId, interactions }
    }
}
